import { FC } from "react";

import { Stack } from "@mui/material";
import { SocialNetworkLink, SocialNetworkPlatform } from "@simplyk/common";

import { FormButton } from "@/forms-design-system/FormButton";
import { Facebook, Instagram, LinkedIn, TikTok, X, YouTube } from "@/icons/socialOutlined";
import { IconElement } from "@/icons/types";

const SOCIAL_PLATFORM_ICONS: Record<SocialNetworkPlatform, IconElement> = {
  Facebook: <Facebook />,
  X: <X />,
  YouTube: <YouTube />,
  Instagram: <Instagram />,
  LinkedIn: <LinkedIn />,
  TikTok: <TikTok />,
};

interface SocialLinksProps {
  socialLinks: SocialNetworkLink[];
  isPreview: boolean;
}

export const SocialLinks: FC<SocialLinksProps> = ({ socialLinks, isPreview }) => (
  <Stack direction="row" flexWrap="wrap" gap={1.5}>
    {socialLinks.map((socialLink) => (
      <FormButton
        key={socialLink.platform}
        variant="rounded"
        size="small"
        iconButton
        startIcon={SOCIAL_PLATFORM_ICONS[socialLink.platform]}
        components={{ startIcon: { size: "medium" } }}
        aria-label={socialLink.platform}
        {...(isPreview ? {} : { href: socialLink.url, target: "_blank", rel: "noopener" })}
        sx={(theme) => ({ width: theme.spacing(4), height: theme.spacing(4) })}
        data-test={`org-page-social-link-${socialLink.platform}`}
      />
    ))}
  </Stack>
);
